// extracted by mini-css-extract-plugin
export var highlightOriginal = "_60-0";
export var highlightSuggested = "_60-1";